import styled from '@emotion/styled';
import { Spin } from 'antd';

const FullContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	position: absolute;
	inset: 0;
`;

export function LoadingSpinner(props: { 'data-testid'?: string }) {
	return (
		<FullContainer {...props}>
			<Spin />
		</FullContainer>
	);
}
